// extracted by mini-css-extract-plugin
export default {"tabs":"AgentSummary_tabs__yuVyp","active":"AgentSummary_active__5tbtX"};